export default class FormSubmit {
    constructor() {
        this.init();
    }

    init() {
        $('form.preventDoubleClick').on('submit', function () {
            $(this).find(':submit').attr('disabled', 'disabled');
        });
    }
}